const topics = [
  { id: 1, name: '韩漫推荐', count: '12.8k', hot: true },
  { id: 2, name: '日漫新番', count: '9.6k', hot: true },
  { id: 3, name: '下拉式阅读', count: '7.2k', hot: false },
  { id: 4, name: '追更心得', count: '15.3k', hot: true },
  { id: 5, name: '漫画收藏', count: '8.4k', hot: false },
  { id: 6, name: '免费全集', count: '6.9k', hot: false },
  { id: 7, name: '热血战斗', count: '11.2k', hot: true },
  { id: 8, name: '恋爱甜漫', count: '10.1k', hot: false },
  { id: 9, name: '漫画大全', count: '5.5k', hot: false },
  { id: 10, name: 'Webtoon', count: '13.7k', hot: true },
  { id: 11, name: '漫迷社区', count: '9.3k', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">大家都在讨论的漫画话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              {topic.name}
              <span className="text-xs opacity-70">{topic.count}</span>
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}